import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

export const PROMO_ID = 'public-benefits-auth';

export const publicBenefitsOfAuthorizationPromo: false | 'a' | 'b' | 'c' | 'd' =
    !IS_WEBVIEW && IS_MOBILE_BROWSER && getFeature(`3promo-enable-${PROMO_ID}`);
